import { FieldMapping } from '../services/api';

/**
 * Finds target fields that are mapped by more than one source field.
 *
 * Excludes targets that are "unmapped" or start with "application.unmapped."
 * (case-insensitive) and targets classified as "not-applicable".
 *
 * @returns Array of [targetField, sourceFields[]] tuples where sourceFields.length > 1
 */
export function findDuplicateTargets(
  mappings: FieldMapping[],
): [string, string[]][] {
  const targetToSources = new Map<string, string[]>();

  for (const m of mappings) {
    if (
      !m.targetField ||
      m.classification === 'not-applicable' ||
      m.targetField.toLowerCase() === 'unmapped' ||
      m.targetField.toLowerCase().startsWith('application.unmapped.')
    ) {
      continue;
    }

    const sources = targetToSources.get(m.targetField) || [];
    sources.push(m.sourceField);
    targetToSources.set(m.targetField, sources);
  }

  return Array.from(targetToSources.entries()).filter(
    ([, sources]) => sources.length > 1,
  );
}
